import { createSelector } from 'reselect'
import { pendingSelector } from 'api/selectors'

export const stateSelector = state => state?.guestUserManageBooking

export const guestUserReservationsSelector = createSelector(stateSelector, state => state?.reservations?.[0] || {})
export const getReservationsByParamErrorSelector = createSelector(stateSelector, state => state?.error)

export const getGuestUserReservationsPendingSelector = createSelector(
    pendingSelector,
    pending => pending.getReservationsByParam
)

export const getGuestReservationAmendPolicySelector = createSelector(stateSelector, state => state?.amendPolicy)

export const vehicleUpdatedSelector = createSelector(stateSelector, state => state?.vehicleUpdated)

export const vehicleUpdateErrorSelector = createSelector(stateSelector, state => state?.vehicleUpdateError)

export const guestUserVehicleSelector = createSelector(
    guestUserReservationsSelector,
    state => state?.vehicles?.[0] || {}
)
